<template>
    <div class="">
        <div class="shadow-lg rounded-lg flex flex-col border-t-4 border-blue-dark">
            <div class="p-2 lg:p-4 rounded-b-lg bg-white" v-if="!loading && hasData">
                <highcharts id="chart"></highcharts>
            </div>

            <new-dashboard v-if="!loading && !hasData" class="p-2 lg:p-4 rounded-b-lg bg-white"></new-dashboard>

            <loading v-if="loading"></loading>
        </div>
    </div>
</template>

<script>
    import NewDashboard from "../components/NewDashboard";
    export default {
        components: {NewDashboard},
        data() {
            return {

            }
        },

        computed: {
            loading() {
                return this.$store.state.loading;
            },
            hasData() {
                return this.$store.getters.series.length > 0;
            }
        }

    }
</script>
